<template>
  <!-- 商品评论 -->
  <div class="commentAudit">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['评论管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="danger"
          icon="el-icon-circle-close"
          :disabled="selectedList.length == 0"
          @click="handleshow(-1)"
          >批量拒绝</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          :disabled="selectedList.length == 0"
          @click="handleshow(2)"
          >批量通过</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">类型：</label>
        <el-select
          placeholder="类型"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.status"
        >
          <el-option label="全部" value="9"></el-option>
          <el-option label="未审核" value="1"></el-option>
          <el-option label="已审核" value="2"></el-option>
          <el-option label="拒绝展示" value="-1"></el-option>
        </el-select>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入产品名称"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column
        align="center"
        prop="user"
        show-overflow-tooltip
        label="用户名称"
      >
      </el-table-column>
      <el-table-column
        prop="goods"
        align="center"
        show-overflow-tooltip
        label="商品名称"
      >
      </el-table-column>
      <el-table-column
        prop="grade"
        label="评价星级"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="time"
        label="评论时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 1">未审核</el-tag>
          <el-tag type="success" v-else-if="scope.row.status == 2"
            >已审核</el-tag
          >
          <el-tag type="danger" v-else>拒绝展示</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="grade"
        label="评价星级"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="content"
        label="评论内容"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "commentAudit",
  data() {
    return {
      /**表格数据 */
      // {
      //   user:"用户名称",
      //   goods:"商品名称",
      //   grade:"评价星级",
      //   time:"评论时间",
      //   status:"状态",
      //   content:"评论内容"
      // }
      tableData: [],
      selectedList: [] /**select选中项 */,
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      searchForm: {
        /**搜索表单 */ status: "9",
        name: "",
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    /**获取管理员数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "PC_GetCriticismsList",
        status: this.searchForm.status,
        strwhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_OperationCriticisms"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "qualification/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          console.log(res);
          this.tableData = [];
          if (res.flag == 0) {
            for (let i = 0; i < res.data.length; i++) {
              this.allPage = res.recordCount;
              this.tableData.push({
                id: res.data[i].id,
                user: res.data[i].name,
                goods: res.data[i].sub_title,
                grade: res.data[i].rank,
                time: res.data[i].addtime,
                status: res.data[i].status,
                content: res.data[i].content,
              });
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    // 批量上架下架
    handleshow(status) {
      let msg = "确定要执行操作吗?";
      let type = "info";
      if (status == -1) {
        msg = "确定拒绝通过吗?";
        type = "warning";
      } else if (status == 2) {
        msg = "确定通过吗?";
        type = "success";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          let data = {
            type: "PC_UpCriticismsType",
            strWhere: this.selectedList.map((item) => item.id).join(","),
            status: status,
          };
          let proc = "Proc_OperationCriticisms"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "criticisms/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "Post",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "info",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.commentAudit {
  width: 100%;
  height: 100%;
}
</style>
